import React, { useRef } from 'react';
import { ExpandableMenuProps } from 'src/app/molecules/Header/Header/HeaderLinks';
import { ProductsMegaMenuSideContainer } from './ProductsMegaMenu.styles';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import ProductsMegaMenuFeatures from './ProductsMegaMenuFeatures';
import ProductsMegaMenuLearnMore from './ProductsMegaMenuLearnMore';
import useElementResize from 'src/hooks/useElementResize';

const ProductsMegaMenuSideBar = ({ isOpen }: ExpandableMenuProps): JSX.Element => {
  const menuContainerRef = useRef<HTMLDivElement>(null);
  const { height } = useElementResize(menuContainerRef);

  return (
    <ProductsMegaMenuSideContainer
      isOpen={isOpen}
      maxHeight={height}
    >
      <Stack
        ref={menuContainerRef}
        direction='column'
      >
        <ProductsMegaMenuFeatures />
        <ProductsMegaMenuLearnMore />
      </Stack>
    </ProductsMegaMenuSideContainer>
  );
};

export default ProductsMegaMenuSideBar;
